import { defineStore } from 'pinia'
import { ref } from 'vue'
import curry from 'ramda/es/curry'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

const isMatch = curry(
    (profID, mcID, x) => x.professionID === profID && x.mainCategoryID === mcID
)
const existsFor = curry((profID, mcID, state) =>
    state.allMainCategoriesStats.some(isMatch(profID, mcID))
)
const findFor = curry((profID, mcID, state) =>
    state.allMainCategoriesStats.find(isMatch(profID, mcID))
)

export const useMainCategoriesStatsStore = defineStore('mainCategoriesStats', () => {
    const allMainCategoriesStats = ref([])

    const persist = () => {
        persistPiniaSlice('mainCategoriesStatsStore', {
            allMainCategoriesStats: allMainCategoriesStats.value,
        })
    }

    const snapshot = () => ({
        allMainCategoriesStats: allMainCategoriesStats.value,
    })

    const existsMainCategoriesStatsFor = (data) =>
        existsFor(data.professionID, data.mainCategoryID, snapshot())

    const getMainCategoriesStatsFor = (data) =>
        findFor(data.professionID, data.mainCategoryID, snapshot())

    const resetMainCategoriesStats = () => {
        allMainCategoriesStats.value = []
        persist()
    }

    const addToMainCategoriesStats = (newStat) => {
        const profID = newStat.professionID
        const mcID = newStat.mainCategoryID
        const state = snapshot()

        if (existsFor(profID, mcID, state)) {
            const index = allMainCategoriesStats.value.findIndex(
                isMatch(profID, mcID)
            )
            allMainCategoriesStats.value[index] = newStat
        } else {
            allMainCategoriesStats.value.push(newStat)
        }
        persist()
    }

    const saved = loadPiniaSlice('mainCategoriesStatsStore')
    if (saved && Array.isArray(saved.allMainCategoriesStats)) {
        allMainCategoriesStats.value = saved.allMainCategoriesStats
    }

    return {
        allMainCategoriesStats,
        existsMainCategoriesStatsFor,
        getMainCategoriesStatsFor,
        resetMainCategoriesStats,
        addToMainCategoriesStats,
    }
})
